import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import router from './router/index.js'
import store from './store/index.js'
import en from './localization/en.js'
import ru from './localization/ru.js'
import VDateRange from 'vuetify-daterange-picker'
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'
import VueCurrencyFilter from 'vue-currency-filter'
import VueUploadComponent from 'vue-upload-component'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import './assets/snotify-material.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'


Vue.use(VueI18n)
Vue.use(VDateRange)
Vue.component('file-upload', VueUploadComponent)
Vue.config.productionTip = false

Vue.use(VueCurrencyFilter, {
  symbol: '₽',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true
})

let browserLanguage = navigator.language

if (browserLanguage !== 'en' && navigator.language !== 'ru') {
  browserLanguage = 'en'
}

const snotifyOptions = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}

Vue.use(Snotify, snotifyOptions)

new Vue({
  store: store,
  router: router,
  i18n: new VueI18n({
    fallbackLocale: 'en',
    locale: browserLanguage,
    messages: {
      en,
      ru
    }
  }),
  render: h => h(App)
}).$mount('#app')